<button
  type="button"
  (click)="showModal()"
  class="kuba-document-trigger"
  [attr.aria-label]="checklistName"
  [title]="checklistName"
>
  <i
    class="pi pi-list-check kuba-document-icon kuba-document-icon--coral"
    aria-hidden="true"
  ></i>
</button>
<p-dialog
  [(visible)]="showModalWindow"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  styleClass="checklist-editor-dialog"
  [style]="{
    width: 'min(1280px, 100vw)',
    height: '100dvh',
    maxHeight: '100dvh'
  }"
  [closable]="!saving && imageBusy.size === 0"
  (onHide)="hideModal()"
>
  <ng-template #header>
    <div class="editor-heading">
      <span class="editor-eyebrow">{{
        (canEdit ? "EDIT_CHECKLIST" : "CHECKLIST_REDESIGN.VIEW") | translate
      }}</span>
      <h2>
        {{ checkListData?.checkList?.title || ("NEW_CHECKLIST" | translate) }}
      </h2>
    </div>
  </ng-template>
  <div class="checklist-editor" *ngIf="checkListData?.checkList as checklist">
    <div class="editor-notice" *ngIf="!canEdit">
      <i class="pi pi-lock" aria-hidden="true"></i>
      <div>
        <strong
          >{{ "CHECKLIST_REDESIGN.READ_ONLY" | translate
          }}<span *ngIf="providerName"> · {{ providerName }}</span></strong
        >
        <p>{{ "CHECKLIST_REDESIGN.READ_ONLY_HELP" | translate }}</p>
        <button
          *ngIf="canCopy"
          type="button"
          class="btn btn-primary"
          (click)="openCopy()"
        >
          {{ "CHECKLIST_REDESIGN.COPY" | translate }}
        </button>
      </div>
    </div>
    <p class="editor-error" role="alert" *ngIf="saveError">
      {{ "CHECKLIST_REDESIGN.SAVE_ERROR" | translate }}
    </p>
    <p class="editor-error" role="alert" *ngIf="imageError">
      {{ "CHECKLIST_REDESIGN.IMAGE_ERROR" | translate }}
    </p>
    <aside class="editor-outline">
      <h3>{{ "CHECKLIST_REDESIGN.OUTLINE" | translate }}</h3>
      <ng-container *ngFor="let section of checklist.sections; let s = index">
        <button
          *ngIf="+section.status !== 0"
          type="button"
          class="editor-outline-link"
          (click)="scrollToSection(s)"
        >
          {{ section.position }} ·
          {{ section.title || ("SECTION" | translate) }}
        </button>
      </ng-container>
      <p>
        {{
          "CHECKLIST_REDESIGN.CHECKPOINT_COUNT"
            | translate: { count: checkpointCount }
        }}
      </p>
      <label *ngIf="canEdit" class="editor-setting"
        ><input
          type="checkbox"
          [disabled]="saving"
          [ngModel]="checklist.scoreIndex"
          (change)="updateScoreIndex($event)"
        />{{ "SCORE_INDEX" | translate }}</label
      >
      <p *ngIf="!canEdit && checklist.scoreIndex">
        {{ "SCORE_INDEX" | translate }}
      </p>
      <div
        class="copy-checklist"
        *ngIf="
          canEdit &&
          checklist.id === 0 &&
          (featureType === 'Manuals' || featureType === 'AssignManuals')
        "
      >
        <p-select
          class="copy-checklist-select"
          [options]="checklistTemplateList"
          [(ngModel)]="copyChecklistId"
          [filter]="true"
          [placeholder]="'SELECT_CHECKLIST' | translate"
        ></p-select>
        <button
          type="button"
          class="btn btn-outline-secondary"
          [disabled]="validateCopyCheckList()"
          (click)="copyManualCheckList()"
        >
          {{ "COPY_SELECTED_CHECKLIST" | translate }}
        </button>
      </div>
    </aside>
    <main class="editor-sections">
      <label class="editor-title" *ngIf="canEdit"
        >{{ "TITLE" | translate
        }}<input
          class="form-control"
          [(ngModel)]="checklist.title"
          [disabled]="saving"
      /></label>
      <div
        cdkDropList
        [cdkDropListData]="checklist.sections"
        [cdkDropListDisabled]="!canEdit || saving"
        (cdkDropListDropped)="reorder($event, checklist.sections)"
      >
        <section
          *ngFor="let section of checklist.sections; let s = index"
          cdkDrag
          [hidden]="+section.status === 0"
          class="editor-section"
          [id]="'checklist-section-' + id + '-' + s"
        >
          <header class="editor-section-header">
            <button
              *ngIf="canEdit"
              type="button"
              cdkDragHandle
              class="editor-icon drag-handle"
              [attr.aria-label]="'CHECKLIST_REDESIGN.REORDER' | translate"
            >
              <i class="pi pi-bars"></i>
            </button>
            <span class="editor-number">{{ section.position }}</span>
            <input
              *ngIf="canEdit; else sectionText"
              class="form-control"
              [(ngModel)]="section.title"
              [disabled]="saving"
              [attr.aria-label]="'SECTION' | translate"
              [placeholder]="'SECTION' | translate"
            />
            <ng-template #sectionText
              ><h3>{{ section.title }}</h3></ng-template
            >
            <div class="editor-row-actions" *ngIf="canEdit">
              <button
                type="button"
                class="editor-icon"
                (click)="move(checklist.sections, s, -1)"
                [disabled]="s === 0 || saving"
                [attr.aria-label]="'CHECKLIST_REDESIGN.MOVE_UP' | translate"
              >
                <i class="pi pi-arrow-up"></i>
              </button>
              <button
                type="button"
                class="editor-icon"
                (click)="move(checklist.sections, s, 1)"
                [disabled]="s === checklist.sections.length - 1 || saving"
                [attr.aria-label]="'CHECKLIST_REDESIGN.MOVE_DOWN' | translate"
              >
                <i class="pi pi-arrow-down"></i>
              </button>
              <button
                type="button"
                class="editor-icon"
                [disabled]="saving"
                (click)="removesection(checklist, section)"
                [attr.aria-label]="'DELETE' | translate"
              >
                <i class="pi pi-trash"></i>
              </button>
            </div>
          </header>
          <div
            cdkDropList
            [cdkDropListData]="section.items"
            [cdkDropListDisabled]="!canEdit || saving"
            (cdkDropListDropped)="reorder($event, section.items)"
          >
            <div
              *ngFor="let item of section.items; let i = index"
              cdkDrag
              [hidden]="+item.status === 0"
              class="editor-checkpoint"
            >
              <button
                *ngIf="canEdit"
                type="button"
                cdkDragHandle
                class="editor-icon drag-handle"
                [attr.aria-label]="'CHECKLIST_REDESIGN.REORDER' | translate"
              >
                <i class="pi pi-bars"></i>
              </button>
              <span class="editor-number"
                >{{ section.position }}.{{ item.position }}</span
              >
              <div class="editor-checkpoint-content">
                <input
                  *ngIf="canEdit; else itemText"
                  class="form-control"
                  [(ngModel)]="item.title"
                  [disabled]="saving"
                  [attr.aria-label]="'CHECKPOINTS' | translate"
                />
                <ng-template #itemText
                  ><p>{{ item.title }}</p></ng-template
                >
                <div class="editor-image" *ngIf="item.referenceImagePath">
                  <button
                    type="button"
                    (click)="previewImage = item.referenceImagePath"
                    [attr.aria-label]="
                      'CHECKLIST_REDESIGN.REFERENCE_IMAGE' | translate
                    "
                  >
                    <img
                      [previewImageSrc]="item.referenceImagePath"
                      loading="lazy"
                      [alt]="'CHECKLIST_REDESIGN.REFERENCE_IMAGE' | translate"
                    />
                  </button>
                  <span>{{
                    "CHECKLIST_REDESIGN.REFERENCE_IMAGE" | translate
                  }}</span>
                </div>
                <details *ngIf="canEdit" class="editor-image-controls">
                  <summary>
                    {{ "CHECKLIST_REDESIGN.REFERENCE_IMAGE" | translate }}
                  </summary>
                  <p>{{ "CHECKLIST_REDESIGN.IMAGE_RULES" | translate }}</p>
                  <p *ngIf="!item.id">
                    {{
                      (canQueueImages
                        ? "CHECKLIST_REDESIGN.IMAGE_UPLOADED_ON_SAVE"
                        : "CHECKLIST_REDESIGN.SAVE_BEFORE_IMAGE"
                      ) | translate
                    }}
                  </p>
                  <div
                    *ngIf="pendingImages.get(item) as pending"
                    class="editor-image"
                  >
                    <img
                      *ngIf="pending.preview"
                      [src]="pending.preview"
                      [alt]="'CHECKLIST_REDESIGN.REFERENCE_IMAGE' | translate"
                    />
                    <span>{{ pending.file.name }}</span>
                  </div>
                  <input
                    type="file"
                    accept=".png,.jpg,.jpeg,.webp,.heic"
                    [disabled]="
                      (!item.id && !canQueueImages) ||
                      saving ||
                      imageBusy.has(item)
                    "
                    (change)="uploadImage($event, item)"
                    [attr.aria-label]="
                      'CHECKLIST_REDESIGN.REFERENCE_IMAGE' | translate
                    "
                  />
                  <button
                    *ngIf="item.referenceImagePath || pendingImages.has(item)"
                    type="button"
                    class="btn btn-link"
                    [disabled]="saving || imageBusy.has(item)"
                    (click)="removeImage(item)"
                  >
                    {{ "DELETE" | translate }}
                  </button>
                </details>
              </div>
              <div *ngIf="canEdit" class="editor-row-actions">
                <label class="editor-enabled"
                  ><input
                    type="checkbox"
                    [disabled]="saving"
                    [ngModel]="+item.status === 1"
                    (change)="updateItemStatus($event, item)"
                  /><span class="sr-only">{{
                    "ACTIVE" | translate
                  }}</span></label
                >
                <button
                  type="button"
                  class="editor-icon"
                  [disabled]="i === 0 || saving"
                  (click)="move(section.items, i, -1)"
                  [attr.aria-label]="'CHECKLIST_REDESIGN.MOVE_UP' | translate"
                >
                  <i class="pi pi-arrow-up"></i>
                </button>
                <button
                  type="button"
                  class="editor-icon"
                  [disabled]="i === section.items.length - 1 || saving"
                  (click)="move(section.items, i, 1)"
                  [attr.aria-label]="'CHECKLIST_REDESIGN.MOVE_DOWN' | translate"
                >
                  <i class="pi pi-arrow-down"></i>
                </button>
                <button
                  type="button"
                  class="editor-icon"
                  [disabled]="saving"
                  (click)="removeItem(section, item)"
                  [attr.aria-label]="'DELETE' | translate"
                >
                  <i class="pi pi-trash"></i>
                </button>
              </div>
            </div>
          </div>
          <button
            *ngIf="canEdit"
            type="button"
            class="btn btn-link"
            [disabled]="saving"
            (click)="addItem(section, s)"
          >
            <i class="pi pi-plus"></i>
            {{ "CHECKLIST_REDESIGN.ADD_CHECKPOINT" | translate }}
          </button>
        </section>
      </div>
      <button
        *ngIf="canEdit"
        type="button"
        class="btn btn-outline-secondary"
        [disabled]="saving"
        (click)="addNewSection(checklist)"
      >
        {{ "NEW_SECTION" | translate }}
      </button>
    </main>
  </div>
  <ng-template #footer>
    <button
      type="button"
      class="btn btn-outline-secondary"
      [disabled]="saving || imageBusy.size > 0"
      (click)="hideModal()"
    >
      {{ "CLOSE" | translate }}
    </button>
    <button
      *ngIf="canEdit"
      type="button"
      class="btn btn-primary"
      [disabled]="saving || imageBusy.size > 0 || validation()"
      (click)="saveChecklist()"
    >
      <i *ngIf="saving" class="pi pi-spinner pi-spin" aria-hidden="true"></i>
      {{ (saving ? "PROCESSING" : "SAVE") | translate }}
    </button>
    <button
      *ngIf="!editMode && isChecklistRights && featureType !== 'Manuals'"
      type="button"
      class="btn btn-primary"
      (click)="completeChecklist()"
    >
      {{ "COMPLETE_CHECKLIST" | translate }}
    </button>
  </ng-template>
</p-dialog>
<ecpl-image-viewer
  *ngIf="previewImage"
  [imgSrc]="previewImage"
  [imgName]="'CHECKLIST_REDESIGN.REFERENCE_IMAGE' | translate"
  [isDialog]="true"
  (close)="previewImage = null"
></ecpl-image-viewer>

<p-dialog
  [(visible)]="showCopy"
  [modal]="true"
  [draggable]="false"
  [closable]="!saving"
  [header]="'CHECKLIST_REDESIGN.COPY' | translate"
  [style]="{ width: 'min(520px, 96vw)' }"
>
  <p>{{ "CHECKLIST_REDESIGN.COPY_HELP" | translate }}</p>
  <label
    >{{ "TITLE" | translate
    }}<input class="form-control" [(ngModel)]="copyName" [disabled]="saving"
  /></label>
  <label class="d-block"
    ><input type="checkbox" [(ngModel)]="hideOriginal" [disabled]="saving" />
    {{ "CHECKLIST_REDESIGN.HIDE_ORIGINAL" | translate }}</label
  >
  <p role="alert" *ngIf="saveError">
    {{ "CHECKLIST_REDESIGN.SAVE_ERROR" | translate }}
  </p>
  <ng-template #footer
    ><button
      type="button"
      class="btn btn-primary"
      [disabled]="saving || !copyName.trim()"
      (click)="copyToBusiness()"
    >
      {{ (saving ? "PROCESSING" : "CHECKLIST_REDESIGN.COPY") | translate }}
    </button></ng-template
  >
</p-dialog>
